import React, { useEffect, useState } from 'react';
import { Button, View, Modal, FormControl, Select, Text, Spinner } from 'native-base';
import { getUserPath } from '../../acebase';
import { liveTTScoreboardButtonTextColor } from '../../../livettscoreboard.config';
import { addNewTeamMatch } from '../functions/teammatches';
import { getMyTeams } from '../functions/teams';
import { newTeamMatch } from '../classes/TeamMatch';
import { DateTimePicker } from '../components/DateTimePicker';

export function NewTeamMatchModal(props) {
    let [loadingNewMatch, setLoadingNewMatch] = useState(false);
    let [teamSelectionList, setTeamSelectionList] = useState([]);


    let [teamAID, setTeamAID] = useState("");
    let [teamBID, setTeamBID] = useState("");

    async function loadTeamSelection() {
        let teams = await getMyTeams(getUserPath());
        console.log(teams);
        setTeamSelectionList(teams);
    }

    useEffect(() => {
        loadTeamSelection();
    }, []);

    let [matchTime, setMatchTime] = useState(new Date().toISOString().slice(0, 10));

    return (
        <Modal onClose={() => {
            props.onClose(false);
        }} isOpen={props.isOpen}>
            <Modal.Content>
                <Modal.CloseButton></Modal.CloseButton>
                <Modal.Header>New Team Match</Modal.Header>
                <Modal.Body>
                    <FormControl>
                        <FormControl>Team A</FormControl>
                        <Select selectedValue={teamAID} onValueChange={(val) => {
                            setTeamAID(val);
                        }}>
                            {teamSelectionList.map((team) => {
                                return (
                                    <Select.Item key={team[0] + "A"} label={team[1].name} value={team[1].id}></Select.Item>
                                );
                            })}
                        </Select>
                        <FormControl>Team B</FormControl>
                        <Select selectedValue={teamBID} onValueChange={(val) => {
                            setTeamBID(val);
                        }}>
                            {teamSelectionList.map((team) => {
                                return (
                                    <Select.Item key={team[0] + "B"} label={team[1].name} value={team[1].id}></Select.Item>
                                );
                            })}
                        </Select>
                        <FormControl.Label>Match Time</FormControl.Label>
                        <DateTimePicker type="date" value={matchTime} onChange={(event) => {
                            setMatchTime(event.target.value);
                        }}></DateTimePicker>
                    </FormControl>

                </Modal.Body>
                <Modal.Footer>
                    <View padding={1}>
                        <Button
                            onPress={async () => {
                                setLoadingNewMatch(true);
                                await addNewTeamMatch(newTeamMatch(teamAID, teamBID, matchTime));

                                setLoadingNewMatch(false);
                                props.onClose();
                            }}
                        >
                            {loadingNewMatch ?
                                <Spinner></Spinner>
                                :
                                <Text color={liveTTScoreboardButtonTextColor}>Add</Text>}

                        </Button>
                    </View>
                    <View padding={1}>
                        <Button

                            variant={"ghost"}
                            onPress={() => {

                                props.onClose(false);
                            }}
                        ><Text>Close</Text>
                        </Button>
                    </View>
                </Modal.Footer>
            </Modal.Content>
        </Modal>
    );
}
